import { Button, CheckboxField, PickList, StatusMessage } from '@krp/ui-kit'
import type { OwnCashierList } from '../model/types'
import './ownCashiers.css'

export interface OwnCashiersListScreenProps {
  list: OwnCashierList | undefined
  loading: boolean
  /** Текст ошибки сервера дословно; `null` — ошибки нет. */
  error: string | null
  canManage: boolean
  search: string
  find: (value: string) => void
  /** Показывать архивных кассиров (по умолчанию выключено: архивный — «помеченный на удаление»). */
  showArchived: boolean
  toggleArchived: (value: boolean) => void
  reload: () => void
  /** Открыть карточку кассира модальным окном. */
  open: (id: string) => void
  /** Открыть карточку нового кассира. */
  openNew: () => void
}

/**
 * Список кассиров нашей системы (RP-CU3): поиск и строки через единый компонент списка, кнопка «Обновить» под списком. Строка открывает
 * карточку модальным окном — ни правой половины, ни выбранного «текущего» кассира рядом. Архивные скрыты, пока не включишь «Показывать архивных».
 */
export function OwnCashiersListScreen(props: OwnCashiersListScreenProps) {
  const all = props.list?.items ?? []
  const items = props.showArchived ? all : all.filter((item) => !item.archived)
  const rows = items.map((item) => ({ id: item.id, label: item.displayName,
    note: [item.archived ? 'в архиве' : null, item.position, item.links.length === 0 ? 'нет связей с источниками' : item.links.map((link) => link.resourceName).join(', '),
      !item.archived && !item.hasCode ? 'кода нет' : null, item.lastName === null ? 'ФИО не заполнено' : null].filter((part) => part !== null && part !== '').join(' · ') }))
  return <section className="own-cashiers-list" aria-label="Кассиры">
    <div className="own-cashiers-list__bar">
      <Button variant="primary" actionId="receipts.own-cashiers.new" disabled={!props.canManage} disabledReason={props.canManage ? null : 'Нужно право управления кассирами'}
        onClick={props.openNew}>Новый кассир</Button>
      <CheckboxField label="Показывать архивных" checked={props.showArchived} onChange={props.toggleArchived} />
    </div>
    {props.error !== null && <StatusMessage kind="error" title="Не удалось получить список" text={props.error} />}
    <PickList searchLabel="Найти кассира" listLabel="Кассиры" busy={props.loading} items={rows}
      query={props.search} onQuery={props.find} emptyText="Кассиров ещё нет: создайте первого кнопкой «Новый кассир»." notFoundText="Кассир не найден."
      onReload={props.reload} reloadActionId="receipts.own-cashiers.reload" reloadBusy={props.loading}
      onPick={props.open} />
  </section>
}
